import * as React from "react";
import { PureComponent } from "react";
import { Customer, CustomerPreferences } from "../../types/customer";
import {
  withStyles,
  WithStyles,
  createStyles,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormLabel,
  Typography
} from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";
import CustomerContactSettings from "./CustomerContactSettings";
import { ContactPreferences } from "src/common/types/customerPrefs";

interface CustomerSettingsFormProps extends WithStyles<typeof styles> {
  user: Customer;
  preferences: CustomerPreferences;
  onPreferenceAndValidationUpdated: (preferences: CustomerPreferences, isValid: boolean) => void;
  onPreferenceUpdated: (preferences: CustomerPreferences) => void;
  textIsDisabled: boolean;
}

class CustomerSettingsForm extends PureComponent<CustomerSettingsFormProps> {
  onPreferenceKeyUpdated = (key: string, value: any) => {
    this.onPreferenceUpdated({
      ...this.props.preferences,
      [key]: value
    });
  };

  onPreferenceUpdated = (prefs: CustomerPreferences) => {
    this.props.onPreferenceUpdated(prefs);
  };

  onPreferenceAndValidationUpdated = (contactPrefs: ContactPreferences, isValid: boolean) => {
    this.props.onPreferenceAndValidationUpdated(
      {
        ...this.props.preferences,
        preferredEmail: contactPrefs.email,
        isMobilePhone: contactPrefs.isMobilePhone,
        preferredPhone: contactPrefs.phone,
        communicationPreference: contactPrefs.isMobilePhone ? contactPrefs.communicationPreference : "EMAIL"
      } as CustomerPreferences,
      isValid
    );
  };

  handlePreferredBranchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.onPreferenceKeyUpdated("preferredBranchId", event.target.value);
  };

  handleRemindersChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.onPreferenceKeyUpdated("remindersEnabled", event.target.checked);
  };

  handleInvitesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.onPreferenceKeyUpdated("calendarInviteEnabled", event.target.checked);
  };

  handleFeedbackChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.onPreferenceKeyUpdated("feedbackEnabled", event.target.checked);
  };

  render() {
    const { classes, user, textIsDisabled } = this.props;
    const { remindersEnabled, feedbackEnabled } = this.props.preferences;
    const contactPrefs = {
      isMobilePhone: this.props.preferences.isMobilePhone,
      email: this.props.preferences.preferredEmail,
      phone: this.props.preferences.preferredPhone,
      communicationPreference: this.props.preferences.communicationPreference

    } as ContactPreferences;
    return (
      <form name="user-settings-form" className={classes.root}>
        <CustomerContactSettings
          customerInfo={user}
          preferences={contactPrefs}
          onContactSettingsChanged={this.onPreferenceAndValidationUpdated}
          textIsDisabled={textIsDisabled}
        />
        <Typography variant="caption">* Required Field</Typography>
        <FormControl margin="normal" component={"fieldset" as "div"}>
          <FormLabel component="label">Other Options</FormLabel>
          <FormGroup>
            <FormControlLabel
              control={<Checkbox color="primary" checked={remindersEnabled} onChange={this.handleRemindersChange} />}
              label="Send me appointment reminders"
            />
            <FormControlLabel
              control={<Checkbox color="primary" checked={feedbackEnabled} onChange={this.handleFeedbackChange} />}
              label="Ask me for feedback"
            />
          </FormGroup>
        </FormControl>
      </form>
    );
  }
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      alignContent: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center"
    },
    contactNumberContainer: {
      display: "flex",
      flexDirection: "row"
    },
    contactNumberInput: {
      flexGrow: 1
    },
    contactNumberCheck: {
      alignSelf: "flex-end"
    }
  });

export default withStyles(styles)(CustomerSettingsForm);
